// Payroll Checklist deep links ("Open screen to fix") add ?from=YYYY-MM-DD&to=YYYY-MM-DD
// so a list shows only the payroll period the checklist counted. The list APIs
// take them as checklist_from / checklist_to and apply the checklist's own date rule.

const DAY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Read the checklist window from the current URL.
 * @returns {{checklist_from: string, checklist_to: string}|null}
 */
export const readChecklistWindow = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  const from = params.get("from");
  const to = params.get("to");
  if (!DAY_PATTERN.test(from || "") || !DAY_PATTERN.test(to || "")) return null;
  return { checklist_from: from, checklist_to: to };
};

const CHECK_PATTERN = /^[a-z_]{1,40}$/;

/**
 * Read a checklist record link (?check=<check key>&from&to) - for screens that
 * list exactly the rows one check counted (In-Out, Bill Reimbursement).
 * @returns {{checklist_check: string, checklist_from: string, checklist_to: string}|null}
 */
export const readChecklistRecords = (search = window.location.search) => {
  const period = readChecklistWindow(search);
  const check = new URLSearchParams(search).get("check");
  if (!period || !CHECK_PATTERN.test(check || "")) return null;
  return { checklist_check: check, ...period };
};

/** The current URL's query string without the checklist params (period and check). */
export const searchWithoutChecklistWindow = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  params.delete("from");
  params.delete("to");
  params.delete("check");
  const rest = params.toString();
  return rest ? `?${rest}` : "";
};
